// src/services/fallbackData.js
// Fotos alojadas en Blogger CDN

export const FALLBACK_STATS = {
  activos: 44,
  encontrados: 19,
  urgentes: 8,
  esteMes: 23,
};

export const FALLBACK_PERSONS = [

  // ── URGENTES ─────────────────────────────────────────────────────────────
  {
    id: "fallback-008",
    name: "Alfonso Mendez",
    age: 65,
    gender: "Masculino",
    lastSeen: "2026-08-13",
    lastSeenTime: "",
    location: "Santo Domingo",
    province: "Distrito Nacional",
    description: "Padece Alzheimer. Salio de su vivienda durante la madrugada. Habria sido visto en los alrededores de Ivan Guzman Clan.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhLAqy3S-sVX7m90iGfih7S6tS76fpYqLG1hzPmr6RY1D59Q4ZCD8M-iTH5PERWCNcCQTsx7YsRcZ2Qb4orcV5sMMZCHnF6mrTEpaKgJqbsMCVj0mVNfY0-JhE9kdW_Ft_jFfBmfSLonylYPSJImorce9MJ0fTDqs0uAPypiHBp7E6JvB0cDUr4phsmib9d",
    contact: "809-758-0276",
    contactName: "Marlene Mendez (hija)",
    caseId: "ESP-2026-0813",
    reportedBy: "Asodofade",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-017",
    name: "Nelson Antonio Paulino",
    age: 64,
    gender: "Masculino",
    lastSeen: "2026-09-30",
    lastSeenTime: "",
    location: "Mirador Sur, Santo Domingo",
    province: "Distrito Nacional",
    description: "Salio a caminar por los alrededores del Mirador Sur. Vestia polo azul, bermuda crema y tenis negros.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhzLed9WGg1r_fWLZv5ZqvUvGnGqAG_Tc-t3-MW6DbLst7rY1vbl00IupY64Z-MyX6AlPD2VgXHL4Ph4Ws4Bi5bqxPYidLoW4e4I5LVdUaU_624MAT9AMUsxcrOqavMR9KpBbMSxoVndjlLkjUDzN6rHYl9_gf-ZBs4xfzQTkd0QQvgqKFbwqfcx2KniUMU/s320/IMG-20260930-WA0119.jpg",
    contact: "829-880-0820",
    contactName: "Familiar",
    caseId: "ESP-2026-0930",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-018",
    name: "Pablo Antonio Jimenez Santana (Ilustre)",
    age: 61,
    gender: "Masculino",
    lastSeen: "2026-07-21",
    lastSeenTime: "",
    location: "Ensanche Isabelita, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Conocido como Ilustre. Conductor de autobus de la OMSA. Vestia franela blanca y pantalon deportivo color gris.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhbYUogX7zBgXgIgpSRBCfgNGPkzKw9zKgNToZ74MaTnILAh469ezMCTgi6uYLr0jr0v7u6bMng7tMcd85pkxhCJ9gEauDd5urajHLKZGfogbOt4txctkXPsqUq20wdSRV657Jd11xv6VxT-2GffP36teytCxZUIrbow_ocldfuHFjtXrfhjMw1cXIzpPx2",
    contact: "849-710-2803",
    contactName: "Familiar",
    caseId: "ESP-2026-0721",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },

  {
    id: "fallback-059",
    name: "Sammy",
    age: 4,
    gender: "Masculino",
    lastSeen: "2026-10-14",
    lastSeenTime: "10:00 PM",
    location: "Los Tres Brazos, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Niño de 4 años desaparecido el 14 de octubre de 2026 a las 10 de la noche en Los Tres Brazos, Santo Domingo Este. Fue encontrado sano y salvo.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhifey1Jb8wdaPZyL74UvfT5vou8tAnfL-KVaPQHNqWtf1Mj3hglpUA7FtyIU1OAPqAHa4TIwdhukj2Fold54ky1o5A9CsSyevw88sIWiiTMtiiNSVOvOJ67zUxm43jIv83u-h80OoC6thaY67oo9K4rVuVf3bqPRqRgVDs3L4enJfzh8TIocpin-L0p8Le/w149-h200/sammy_encontrado2.jpg",
    contact: "809-798-9972",
    contactName: "Familiar",
    caseId: "ESP-2026-1014SM",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "¡Fue encontrado sano y salvo! Gracias a todos los que compartieron y colaboraron.",
  },

  // ── DESAPARECIDOS ACTIVOS ─────────────────────────────────────────────────
  {
    id: "2a19939e-8268-4603-ad0d-47c9e3ecaec9",
    name: "Sofilio Abraham Jimenez Sanchez",
    age: 31,
    gender: "Masculino",
    lastSeen: "2026-03-07",
    lastSeenTime: "02:00 AM",
    location: "Villa Mella",
    province: "Santo Domingo",
    description: "Ojos negros, barba, color mestizo.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhPzLX1v_HSZhpZbODLkSFeYZnSOsNnBhyjHXekx_655kjq_Elg6BZ8Rtb8pdPijq6UHfc5R_3aIixU4T8k_t5jyxmsb5ivyBwXoY4fB5Mjn_PpottE47WeT1KbgtBXfjPGnLAeQDzSFBjTTDDpohZetPgtXhqJ-lG8tvGVlKnc0qV0EWZ5zjUHSQVItViI",
    contact: "829-305-8877",
    contactName: "Esposa",
    caseId: "ESP-2026-5428",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-001",
    name: "Eridania Vargas",
    age: 43,
    gender: "Femenino",
    lastSeen: "2026-03-01",
    lastSeenTime: "",
    location: "Municipio de Esperanza, Valverde",
    province: "Valverde",
    description: "Presenta condiciones de salud mental. Oriunda del kilometro 5, Moca.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEg5fViDlwJNHIB-dFOVU6w8DXOA_3ffBD9VVbfAAxC_Y8J0-O9UdebzFIMnxIBLfnJt0CAjRIx4VyI3c7l3EBiazJsGqbpVs8gmyIE9zCE2dSgUw_9BK-PLN-daMB53OhOOYwrJvLYUVRi5eyqQcRJXnz4QVKyQOn5BWUCw34GQAV0wSRDBpuvZDTwMaX-w",
    contact: "809-694-1395",
    contactName: "Familiar",
    caseId: "ESP-2026-0301",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-004",
    name: "Karsten Hubner",
    age: 64,
    gender: "Masculino",
    lastSeen: "2026-03-06",
    lastSeenTime: "12:00 PM",
    location: "La Caleta, Boca Chica",
    province: "Santo Domingo",
    description: "Ciudadano aleman. Padece enfermedades pulmonares y sanguineas. Tez blanca, estatura y contextura medias.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgGOn0kKiqfZeA53yDB0yb_1tz3LLQpOA0JS8TaZ_VyswIdnRHIYgSRSJTBmH_3wLSb15z2qMYRgOE8DVkVhRmsQp1ZgeCtzYI7GRxTQ_99PQg5hAnS4hcPYsnjqKgOjSFEo40H0bVTTfh9qxxVUYXR__fWQLSlWxRzJbJ_kSHnceophFgWxSwNsUdLTYER",
    contact: "809-644-1544",
    contactName: "Familiar",
    caseId: "ESP-2026-0306",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-007",
    name: "Andres Santana",
    age: 69,
    gender: "Masculino",
    lastSeen: "2026-08-24",
    lastSeenTime: "08:00 AM",
    location: "Sabana Grande de Boya, Monte Plata",
    province: "Monte Plata",
    description: "Vestia t-shirt verde y pantalon jean azul claro. Cabello cañoso. No usa telefono celular. Salio a cita con el dentista en Santo Domingo.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjnZel6mH4DS2knmWmez5RiQsWRErfMUVDvE7YOXFUscGRjd15LJKEG8d5J_jLiq7MVOYtf55sR8UQ_TLoMeyS7Vv94UC8ZxzePzSIr-6TWiAB_yeqElS_VMWY41kAoaXOzT3DYd0jDOA-SrQhLeUUTPywUBt9I6YqEQMOQZ4eBZJ1JOc7VIsj3J9o4_PD7",
    contact: "829-714-3808",
    contactName: "Rafael Andres Santana (hijo)",
    caseId: "ESP-2026-0824",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-006",
    name: "Joan Genao",
    age: 15,
    gender: "Masculino",
    lastSeen: "2024-10-24",
    lastSeenTime: "",
    location: "Almirante Solares, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Vestia franela blanca, bermuda azul y sandalias Nike verde con blanco. Salio supuestamente a un centro de internet. Lleva mas de dos años desaparecido.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgfB95NAyOa7VKMMRCO8_B36Tt3UfFr-s_NyL2GopxLgMQIHhQfuolqhMv6TnS4JQJ2lJSvcSjNI3toY6Ek3hGnJosxPqiNE_WRnJ83vBPi5i4q2G007uqiCcGxbcAZ5MTzLVgZv8Qs7aE6kII0i_76xuN8kdQHS3mjJMsdh8A73Ekhmd4L_MCwp5ykO3bu",
    contact: "809-913-7757",
    contactName: "Breinny Genao (madre)",
    caseId: "ESP-2024-1024",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-009",
    name: "Luis Angel Gonzalez",
    age: 9,
    gender: "Masculino",
    lastSeen: "2022-02-06",
    lastSeenTime: "",
    location: "Batey Paja, Vicente Noble, Barahona",
    province: "Barahona",
    description: "Desaparecido desde el 6 de febrero de 2022. En noviembre cumplira 10 años. Por el caso fueron acusados Anderson Perez (expadrastro) y Jonainy Mendez, ambos en libertad tras cumplir 18 meses de prision preventiva.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjM42rEfD7w3nhMhRYlHMpuc8HxlsYxkPMq301lO170Pe4_8ubR3h92DFXAy4_TzpfKKtE79O2xcZmUsonrfwjZTXebcrKVdF--Fcf9ZJMVzdQ4tZfr2eehRVakZUJfZkedMIjt1kUKwqhTEZ6DF5z1joAOcYlldCOuiKj07eLxEAXrqAZpMu1jMkVGGOdk",
    contact: "849-374-5016",
    contactName: "Familiar",
    caseId: "ESP-2022-0206",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-010",
    name: "Ruth Esther Paredes",
    age: 11,
    gender: "Femenino",
    lastSeen: "2023-01-01",
    lastSeenTime: "",
    location: "La Caleta, Boca Chica",
    province: "Santo Domingo",
    description: "Desaparecio en 2023 con solo 11 años. Su madre Sharina Ramirez ha luchado sola. Dos personas imputadas que confesaron ante la DICRIM quedaron libres por falta de pruebas.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhMWSVuwrI3G_eSaTkxHBq6OMmmCvrZ_qNaTOcH9cvOMugg2HgpK-92AhFbSJhh_t3FxxYutUNWNbsVu-8-PoXrsU15fsg6FPc4S2qORiXh_R85_YSm0ZqHmIOKge5C79WqhUVuAWKjj6ux-4r4Eh0Br7BgeDf2KcP9EqDPDL11FbVKmh7_7mlLvM2qNj0j",
    contact: "829-570-0054",
    contactName: "Sharina Ramirez (madre)",
    caseId: "ESP-2023-0001",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-011",
    name: "Genesis Figuereo Paulino",
    age: 21,
    gender: "Femenino",
    lastSeen: "2026-09-01",
    lastSeenTime: "04:00 PM",
    location: "Santo Domingo Norte",
    province: "Santo Domingo",
    description: "Vista por ultima vez a las 4:00 PM en Santo Domingo Norte.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEj8yC29AfZAYvW0HTbn40hXeGgFHYzcixWbW8xXu54RpP9TRLHsIQmpYZw_NkYPKv48iZH4P3AujVGb-KSiau0fTnM6Vf1tQzG-A8zzRPQG4p4JVD9q5KVAq0hOMONJYwFErsX9jaFwmiOnsp1AIV6zjIAk9jLGa_rsmfqLJHUB19CIzbexJowXsirPMuDa",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-0901",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-012",
    name: "George MacDermid Lopez",
    age: 6,
    gender: "Masculino",
    lastSeen: "2026-08-28",
    lastSeenTime: "",
    location: "Manning Town Centre, Canada",
    province: null,
    description: "Menor de 6 años nacido en Republica Dominicana. Visto por ultima vez con su padre Scot MacDermid en Canada. El padre tiene empresas en Puerto Plata, RD.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgwwpM_TeL5kmltQF9DvDMFr0lV4QnXgqacDCXv1thLhGvH9BzHVp9v1UBDE1AY_NXiqDTUFLEJlheEiV7tYyodpFf_yMrGKw9vf7tKJxZhVz9Mi8knGsx5XJ7CYkezBTlqveWksqndgYSpxmxYnSNVAMnuvUh3P5oaGCc36kSY-Yha-sLTt7goCZar5RDS",
    contact: "DM @vuelveacasard",
    contactName: "Edilenia Lopez (madre)",
    caseId: "ESP-2026-0828G",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-013",
    name: "Lesley MacDermid Lopez",
    age: 9,
    gender: "Femenino",
    lastSeen: "2026-08-28",
    lastSeenTime: "",
    location: "Manning Town Centre, Canada",
    province: null,
    description: "Menor de 9 años nacida en Republica Dominicana. Vista por ultima vez con su padre Scot MacDermid en Canada. El padre tiene empresas en Puerto Plata, RD.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgxJKDCqBlyBgWDQO7klpV9DueWSK5C9s1qQQ8c9gnhDtQ3uzB-uYIMp_Uc0DT3UrkP4_ATSd4UqVh43lRCMTWQyisZmoiin5z30gnKFTo4Ut8_CF6FFim8UIC6CFkIEx9NCDRPUFZ6pDfYePHHl37-KlOuRxQ2hfKbLcKlKOjYmWgv220QUByqcCjgaFc",
    contact: "DM @vuelveacasard",
    contactName: "Edilenia Lopez (madre)",
    caseId: "ESP-2026-0828L",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-014",
    name: "Johanna Lisbeth Contreras",
    age: 22,
    gender: "Femenino",
    lastSeen: "2026-06-10",
    lastSeenTime: "",
    location: "Sector La Cienega, Distrito Nacional",
    province: "Distrito Nacional",
    description: "Madre de un nino de 4 años. Vista por ultima vez abordando un vehiculo con el militar Gerson Sanchez Duran. El imputado habria confesado haberla matado y lanzado al mar.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEj1UJIQqbefkQlj671wlxQjXUw5QJ30tfXjX1dOr_nuxyRnOYAC5xmMzLhCVYxqdx1I11GB9JgTElrQoJ8xvL2UiXZ9lyfsawAGD5BmD2rJ29vS9llHg5VjQCE1jnpO8ybnU0G0SBsFnCGA2N71tOnxWKx2KrBlWs6QNs6csYwisqHZE4vIVvzNV1rL1xFC",
    contact: "9-1-1",
    contactName: "Israelina Contreras (madre)",
    caseId: "ESP-2026-0610",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-015",
    name: "Miguel Enrriquez Santo Munoz (Kiko)",
    age: 30,
    gender: "Masculino",
    lastSeen: "2026-04-01",
    lastSeenTime: "",
    location: "Azua",
    province: "Azua",
    description: "Conocido como Kiko. Desaparecido desde abril de 2026 en la provincia de Azua.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEi1IpNaSYJSeZrKiEun7kezV6GBzP7Ikj_CdrL9NVM2NV3ZnxVZaXcBfYMElFI0zaVHiF3XiR2c70UwUzoeUKSyHam--yNF4BkOx34YV7PFFpB1QHT1ZLQYO2NH7QBE8gjK3R8czZFew9U6Q4_2bw7Zg3NVI9DWmHHsoorZZEiZkpYOXfr-YCxat9e4A5yu",
    contact: "829-931-5419",
    contactName: "Familiar",
    caseId: "ESP-2026-0401",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-019",
    name: "Jose Antonio Bastidas",
    age: 25,
    gender: "Masculino",
    lastSeen: "2026-05-01",
    lastSeenTime: "10:00 PM",
    location: "Punta Rucia, Puerto Plata",
    province: "Puerto Plata",
    description: "Ciudadano ecuatoriano. Salio en embarcacion desde Punta Rucia con destino a Puerto Rico. La embarcacion se volco. Estatura 1.70m, contextura gruesa, piel trigueña, cabello negro, tatuaje de espada en mano izquierda.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgBlQ1GW4mVPoT9LD7iEyCFbRGdnTbvISKAf5pRq6p9Anp2xT_NyAJs2RF2ZnwI8lW4fx0FWcbZsRO-JiHRwtB24u_sRmrhPxI9GYfjbY3YdDo5eFbyrRadD0A7cfPePpjR7X_OGVFNM0qPWRYI_2VoMkS8v67I-umdI_i52XjSh_sa5PWTHIdCQEGUAc0l",
    contact: "+1 845-659-9245",
    contactName: "Ana Bastidas (hermana)",
    caseId: "ESP-2026-0501",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-020",
    name: "Elizabeth Canario Suarez",
    age: 39,
    gender: "Femenino",
    lastSeen: "2026-07-08",
    lastSeenTime: "",
    location: "Nagua, Maria Trinidad Sanchez",
    province: "Maria Trinidad Sanchez",
    description: "Madre de dos hijos. Desaparecida desde el 8 de julio de 2026. Su expareja Richard Ovalle esta detenido para fines de investigacion. Sus familiares ofrecen RD$300,000 de recompensa.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhzM-8SpAWacQZ1gNedXvd6M9uvKuucBU_ePzf9u8ce-6wXikjN10c0tBOcDvsieo_jajHzThVlwLfhx7S7u3qV2yZWhnN8wvtHHhlgk3qeHCtd08zwXfqRgrpynEQWE9u_exeuqJH_sPmTMCtdXjVy-5Fs7Cky3Xst61rglVP2Kj_IbLkE2lV6nxFuzNnz",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-0708",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-021",
    name: "Yeralbin Franco Reyes",
    age: 40,
    gender: "Masculino",
    lastSeen: "2026-06-23",
    lastSeenTime: "",
    location: "Matanzas, Punal, Santiago",
    province: "Santiago",
    description: "Oriundo de Matanzas, Punal, Santiago. Salio con destino a Puerto Plata y desde entonces no se tiene informacion.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjdySd5SmVMcKrMNQ9hDARd5YeFVin0fFYdWVcbn9VqpuinHWoJG9gbC7AFptrKW4Jjs44FYIFeeVa4qfRfyPKikNfnjFKPIrIgFKUcR_XH2eMtmcKWNxEaBJGqsU_Nm-vn3JVt4WQ90xXcGsRz56CpiUVXm5WaYLm4x6Ig5YAo93YhBEVXK7vDVgEz0M2Y",
    contact: "DM @vuelveacasard",
    contactName: "Familiar",
    caseId: "ESP-2026-0623",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-022",
    name: "Christian Evelio Mata Ramirez",
    age: 39,
    gender: "Masculino",
    lastSeen: "2026-07-07",
    lastSeenTime: "",
    location: "Autopista Las Americas, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Padece esquizofrenia y trastornos mentales desde su nacimiento. Al momento de salir no estaba medicado. Visto descalzo, sin camisa y con bermuda corta en la Autopista del Nordeste proximo al peaje de Las Americas.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjhH7N-n27mz1lXk1r6BNn5OsRSEMitT1C20W1LX5yvYYLAHNhzv8O3WTthNAdsNmtoHXu9WElpNfBQR4NeaRmuUhnDgcWmT4nQ3s1Q2aUqP-qPRPL3E4R-n5nu_OHLg4vnna-12YejuWWmZDTMmEJHVI-3JPe3PHzvIn-zq4U2n4Ohg_327K-z4E93dRjx",
    contact: "809-449-0005",
    contactName: "Familiar",
    caseId: "ESP-2026-0707",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-023",
    name: "Rosa Marte",
    age: 45,
    gender: "Femenino",
    lastSeen: "2026-07-10",
    lastSeenTime: "07:00 AM",
    location: "Barraquito, Villa Riva, Duarte",
    province: "Duarte",
    description: "Abordo un automovil negro frente a su residencia a las 7:00 AM. Sus familiares dicen que no acostumbraba a salir sin informar.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgpcHIldUi8ewqOBZFhyJ4i5oXIFCb8Veid8PbxRXT817HI_DbQXEB213Fd3PdUQBHEkF4Tdp1_hKm_6SVHzxTVudqRhN_wTm54BFe1642fRALsP7nJ5xUfLTDwTIyIEpVrXT6B4JlJtHGDgI-2T58OBZryZnhQHvS9nC_nDLBp8VSiSwMaWXYFD4Su5g8c",
    contact: "829-496-2856",
    contactName: "Familiar",
    caseId: "ESP-2026-0710",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-024",
    name: "Fradimery Valadez Laurencio",
    age: 17,
    gender: "Femenino",
    lastSeen: "2026-07-04",
    lastSeenTime: "",
    location: "Los Jardines de Genoveva, Villa Mella, Santo Domingo Norte",
    province: "Santo Domingo",
    description: "Menor de 17 años. Residente del sector Los Jardines de Genoveva, Villa Mella.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjf1tCMg83GwuyQEcdnhqa9iQTr-r3-I_iFnsLgbg2yCJYMPPSFNl0CTYuTyr-6Ua9UxP6P94sCTzRe1R6q7yYR7CRmi1wWLHQNZTIsSiOor1BuEIUD7wvEzJbibjXWp78T_d-378qVf5fMrf3hW4F59UeDwGow60SIT3K7Yr8Y0KqOA13idD2o9MwykFsR",
    contact: "829-844-9832",
    contactName: "Familiar",
    caseId: "ESP-2026-0704",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-025",
    name: "Alexander Gomez",
    age: 50,
    gender: "Masculino",
    lastSeen: "2026-06-24",
    lastSeenTime: "",
    location: "La Guaira, Venezuela",
    province: null,
    description: "Venezolano desaparecido desde el terremoto del 24 de junio de 2026 en La Guaira. Residia en OPP27, Entrada a Playa Los Cocos. Cabello cañoso, tez morena, contextura media.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjt6jr6IV9wj_XN3BFuYqAKMUuxA2AgmIGtOObfEZodhWflaB2Fhdf8WGQDjeIw9tDpuOY4zWkqj7-i1ObSa5guyEDrLGyIB1QxG3meUjM8u6tuL7fiLGjEAS4-2h_aKbNP78HSpDuOtvjJcsqXODEPum9m1uxtU9oQ5tcD7EuL1CCd-I5-O_fv07exbx0j",
    contact: "0414.233.26.18",
    contactName: "Briggitte Dominguez (sobrina)",
    caseId: "ESP-2026-0624",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-026",
    name: "Jose Elias Severino Filon",
    age: 50,
    gender: "Masculino",
    lastSeen: "2026-07-14",
    lastSeenTime: "",
    location: "Urbanizacion Cerro Alto, Santiago",
    province: "Santiago",
    description: "Fue visto por ultima vez al salir de los multifamiliares de la Tabacalera, urbanizacion Cerro Alto, Santiago.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEj2rkWSpxubR3_FlrogUzdoBa-96qO-q2QbmeJ-CYgn8rTIXQdEIVoik9gSQtby418mzzslkw8jr_vwb5m0dgeJx53hXelCZSk5jw9KYK6vS-vCJDQoLcTX4HW7ErBpGnuGoptd-Fmy34ccMaNJVkTw3qQttD7940x7lZbwTiR5fE2JswRPsw8MHaPdy-cj",
    contact: "809-606-3773",
    contactName: "Rafael Filon",
    caseId: "ESP-2026-0714",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-027",
    name: "Angie Elizabeth",
    age: 13,
    gender: "Femenino",
    lastSeen: "2026-06-19",
    lastSeenTime: "",
    location: "Sector La Venta, Santo Domingo Oeste",
    province: "Santo Domingo",
    description: "Menor de 13 años. Vista por ultima vez el viernes 19 de junio de 2026 en el sector La Venta, Santo Domingo Oeste.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgKW7BzQT_PauRMpHY9CTLn2w_d2eMq-UDMaA7XaOSOUvhDXuf6uxEXI-IrdWavPvEjSYSqONDXBhXVh_qp2WirUTEnB1e99r7uW-DywxTtq2iSfyojoq0jvzeflp0US1xAqMnOVvvuPdBSlRZV--I9ZESHRyXM83GSSkIbSwTsTCvzBhukNNSC5QPSLYEJ",
    contact: "809-407-3946",
    contactName: "Gloriby Pimentel (tutora)",
    caseId: "ESP-2026-0619",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-028",
    name: "Pablo Ramirez",
    age: 31,
    gender: "Masculino",
    lastSeen: "2026-06-23",
    lastSeenTime: "",
    location: "Marginal de Las Americas, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Visto por ultima vez la noche del 23 de junio de 2026 en las inmediaciones de la Marginal de Las Americas.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEi0M20L2wKfa22EcdUZ9uiMOt_ucvQ7wzMDO-l1Yr9ZZssJ5lFskC74SWmnYIuMWqTGZsTSiUbE6JipZlv95xdWhf4VvfqJaT1wFFEYnEH4aXUIU2MC9hk1iUv3xc7oNwKqcel2Uz0fXPD70zjEk3T4H-hBxQvSV3j7YuZjOliPYKnv_GKIFLfcZysWWmP9",
    contact: "809-914-6262",
    contactName: "Familiar",
    caseId: "ESP-2026-0623B",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-032",
    name: "Dewin Stalin Batista",
    age: null,
    gender: "Masculino",
    lastSeen: "2026-06-24",
    lastSeenTime: "",
    location: "Consuelo, San Pedro de Macoris",
    province: "San Pedro de Macoris",
    description: "Comunicador y productor audiovisual. Se traslado al municipio de Consuelo para entregar trabajos de diseno audiovisual y desde entonces no se ha tenido comunicacion.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjFtmDtyJrJ1eCVhOpfYP_I7JqkqgmO85kjAHQjBYOMKOvigqVK8ZwS5ighhctj4lDhCOhMOBc33ESq2mOn8tlIASfMmCN1m73xhGtWE0cmy0B0I7L0cXr8dqgvy7z4iHYjjn-UBgHiA5df96RKyDEIp3eVnZsxLiULQyA-l-arpNT0RxJHr0ng3TKSvkp6",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-0000D",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-034",
    name: "Alexander Enrique Pena Perez",
    age: 42,
    gender: "Masculino",
    lastSeen: "2026-06-17",
    lastSeenTime: "04:17 AM",
    location: "Avenida 30 de Mayo, sector Luz Consuelo Sur",
    province: "Distrito Nacional",
    description: "Conductor de la plataforma Uber. Salio a realizar labores y nunca regreso. Captado por camaras de seguridad a las 4:17 AM en la avenida 30 de Mayo.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEiXt0-gW1CpdlH-0xumPYlZ5IixwyYwjfcKYvDUCyOoHPN7jCy1J7KwJV7L_Gh5Gahfj_hjSGshlG2hAMeB3JBe4rxAombsjyp1GJraAPoKWCEkuiSPkellFCiHT5sLirb2YfrgT14_rwwfwpLqZJxzyrn6Pfy56YouuAMelbQGqBWZKccGKr0aIwT9SYyx",
    contact: "849-267-4297",
    contactName: "Familiar",
    caseId: "ESP-2026-0617",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-035",
    name: "Alanna Michel Feliz",
    age: 26,
    gender: "Femenino",
    lastSeen: "2026-06-16",
    lastSeenTime: "",
    location: "Vista del Eden, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Residente del sector Vista del Eden. Denuncia presentada formalmente ante la Policia Nacional. Familiares exigen revision de camaras de seguridad.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhGS9_Y4XmpcEDwYSLPTakrq7ntyVxWnq8EB5q44d8IEkIT5uiB9mqTwVNgq30i4ry7seoEopY6jdwMgtO5hAI7aSg3TF-1f7EIjxFnKhr4PyVzo5OOH-F9PCyOQXBFwnM1xez1ARUPlcO_qvYHNepAq_gF9n-8yNJj45VnJTMBQnPjvW2dSD9viF8EokUb",
    contact: "849-884-7999",
    contactName: "Familiar",
    caseId: "ESP-2026-0616",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-036",
    name: "Norma Lopez Diaz",
    age: null,
    gender: "Femenino",
    lastSeen: "2026-06-06",
    lastSeenTime: "",
    location: "Parque de La Caleta",
    province: "Santo Domingo",
    description: "Vestia vestido negro con flores. Estatura aprox 1.60m, complexion media, tez morena, cabello corto. Familiares ofrecen recompensa de RD$50,000.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgDEFBlSD5a6nmptthmebaYnqHGdWnqlGbzSj_Eq0E14oFrPNEaKf-X9dcSgbW-maWr0ExMOccZbg4xXymBdqedkD6l7eU_ZWm7BtcAqre7UOkm2BjiOyUcdB5BwNR7o9gd-wnDENF1iOqTZabEfOoYeLkUvhjuMJqRFKzZILGGAC3b3qtqAxRMJEy_smvT",
    contact: "829-602-0167",
    contactName: "Familiar",
    caseId: "ESP-2026-0606",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-037",
    name: "Estefani Raquel Taveras",
    age: 39,
    gender: "Femenino",
    lastSeen: "2026-05-31",
    lastSeenTime: "",
    location: "Montecristi",
    province: "Montecristi",
    description: "Madre de cuatro hijos. Desaparecida desde el 31 de mayo de 2026. Su madre y familiares expresan profunda angustia por la falta total de comunicacion.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgP-k0TeOU5_aM9k3EdXQrvSs_Xh4I_6-eAc6dd2xWU2Q64qwzh2RFGaSWS5xzMuSX_87ZPo2C0KTNa8qXikVdKktT1_zuimc0pV7reQA3jNsQvvxuklfS6WXfJuoqpcITbaqH16VstsQ_ESQFVibZLFon7De368nqmhmbCuL0rp7JG7c8mYoJzc834Vg0r",
    contact: "849-446-5282",
    contactName: "Familiar",
    caseId: "ESP-2026-0531",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-038",
    name: "Yocaima Ramirez Alcantara",
    age: 17,
    gender: "Femenino",
    lastSeen: "2026-05-14",
    lastSeenTime: "",
    location: "Barro Arriba, Azua",
    province: "Azua",
    description: "Adolescente de 17 años. Salio al liceo el jueves 14 de mayo 2026 y nunca regreso a su hogar.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhuvqxYvPWT5CFRjVLD3xeDoZGTeeC07uMHQ9JhasmrSA5Lf1o2a9iWUbQt9PDg7drNSaRIs3ypuZ8izQhrnkZALMarM0yp-i8CDXBNpxb0FwjInvFYr84jlHEe1FMcCudBu7dodURPS0c_j-1o1t9RgVda50C75Ib2kAYjPL7rEOKZ56qCOLSHU9n7iQq",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-0514",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-039",
    name: "Yesica",
    age: 12,
    gender: "Femenino",
    lastSeen: "2026-05-16",
    lastSeenTime: "06:10 AM",
    location: "",
    province: null,
    description: "Menor de 12 años. Vista por ultima vez el sabado 16 de mayo alrededor de las 6:10 AM.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEh8H2Jt7GUMFwlISpwqHa_HSKAhusIv15EiGzAvuXpHKSzd2Qk8RDcR34rLPschpgYAxuR6snQf2fA3JuaZtyFKHNuhHid_8lzlwdWp9oWKDpeuQEth-oQwJLvirBcesn3MsBLprkP4-uYi0R0LmJ4xUfQ_sY_B-CpuVNt_jwFemH2oVpftC2Es49RauwTX",
    contact: "849-633-5393",
    contactName: "Familiar",
    caseId: "ESP-2026-0516",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-040",
    name: "Meiry Santana Santana",
    age: 35,
    gender: "Femenino",
    lastSeen: "",
    lastSeenTime: "",
    location: "Los Girasoles, Sabana Grande de Boya",
    province: "Monte Plata",
    description: "Oriunda del sector Los Girasoles. Lleva mas de tres años sin contacto con su familia. Su madre Ana Santana hace un llamado desesperado.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEiKn6ie3yb39PuI3VaN61RfsiG6vNGTrir9_tq-8Km6r6yaeQZp5P31dWy-AvdxWKEQTSqKgKO-f9PqqHC7y9oOiQbSXMwX-ffMpwS4b_YzKGQi-6tLBQQCHfY56iui7EEwi5SIwlttiEEFH92zYaA42l6I2Z-Q_5b5WBlS9WIkM-pmesK56diArpzbqIeo",
    contact: "829-419-9390",
    contactName: "Ana Santana (madre)",
    caseId: "ESP-2023-0000M",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-041",
    name: "Bienvenido Eusebio",
    age: 57,
    gender: "Masculino",
    lastSeen: "2026-05-21",
    lastSeenTime: "03:53 PM",
    location: "Cruce de Veron, Punta Cana",
    province: "La Altagracia",
    description: "Salio de su residencia con destino a Veron. Vestia sueter verde, pantalon jean y tenis blancos. Acudio a un encuentro coordinado por plataforma digital con una persona que ofrecia venta de numeros.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhgcIxreQxW6prvzldSMTFeJjuH0BIA9kc88BEsIYi0TgTZVlv5gFbP4hGoDeKTYqJljYXEEnKpLXModrlWkcEPa3zmFhmLvH_z-3suPj5Z6Wjottjm70jxtdaRrMfWnHBxv6sv2EJ_cWmsZfTxlSpwV0ebRwj2ROf5HZu_u0t7rZjf41XwYwS6Ci5jiKJ8",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-0521",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-042",
    name: "Deneysi Almonte",
    age: 19,
    gender: "Femenino",
    lastSeen: "",
    lastSeenTime: "",
    location: "Brisas del Este, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Joven de 19 años en estado de embarazo. Salio de su hogar con rumbo desconocido luego de una discusion familiar, acompanada de su hijo.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEj7_L53fAM9yoz0B923dy8EHUl1RO9hW2mUj8_pb9yTKlur7eqSSeBXzngILlRl3n-x7dZGGr2dvkKXKI0r7eayWJsFFffRq2i1xm3R6MMK23JvC4yNbK__fNB8dIcmi6pC0mayHuj6bRjqfIkJdkpSGJRcAWOn0Kqgw6JpnmZdYbD1gYjFHefah2smlcEU",
    contact: "849-628-1002",
    contactName: "Familiar",
    caseId: "ESP-2026-0000DA",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-043",
    name: "Gabriel Lopez",
    age: 68,
    gender: "Masculino",
    lastSeen: "",
    lastSeenTime: "",
    location: "El Torito, Villa Mella, Santo Domingo Norte",
    province: "Santo Domingo",
    description: "Padece principios de Alzheimer. Lleva aproximadamente un mes sin que su familia tenga noticias de el. Familiares ofrecen recompensa de RD$50,000.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjN_xJHKt-qeMIjUgZ5E5iGZeJLavV54HD2rIWmEs4bfjz478sH3uNcbLnlOearUACwdyJ8_dmjn_N70izYqmNJRO9HrORyBdcD1QIcYLhWyTKx5XO2zm-EreFBA1Oqcjlh_WMpJQP38m1IvrVCtoB61Mw5XkACgd5eERH076T2Ycpgtxl4PSGwfIj5Gudn",
    contact: "829-927-4772",
    contactName: "Familiar",
    caseId: "ESP-2026-0000GL",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-044",
    name: "Alicia Colen",
    age: 28,
    gender: "Femenino",
    lastSeen: "",
    lastSeenTime: "",
    location: "Villa Caoba, calle 34, La Romana",
    province: "La Romana",
    description: "Joven de 28 años. Lleva aproximadamente una semana desaparecida. Familiares han iniciado una intensa busqueda.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgiKreehMpeQRLm5oXcF0eGtYcPzTD2JEuEkJwQGtDwlOF4dHWbZTSPYylcXYZOtNWvbFnUxXaF57NW53uhYrMFKcT7DUAlk3y0A7cmwaqf9ImzkgoHs78_2SJYHQg7FUOfNlNMj5Ov7045E218JPgArd43O5L6u4RI89Ce9xDCZNEZ-kPwms6Jk8uEGzVE",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-0000AC",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-045",
    name: "Francisco Alberto Peralta Puello",
    age: 54,
    gender: "Masculino",
    lastSeen: "2026-04-19",
    lastSeenTime: "11:00 AM",
    location: "Ensanche Bolivar, Santiago",
    province: "Santiago",
    description: "Reconocido vendedor de comida rapida. Salio de su residencia con destino al mercado El Hospedaje Yaque. Vestia poloche azul, pantalon jean y tenis blanco con rojo. Negocio de comida rapida por mas de 28 años.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEix7zg8jLGpHUy5opTYwhHf9igoGZ_GMbWJZ4DcoTiDWg4Rufm-gmY5zMePt_3pcLr1tNC7oGVQSQ0w4YLQEuBdupGvB325Br507iSDDNxcVQSbgygGsg4fiFR1NtAaTbz0Noc13uNzVqbPZ9zROiMLsjPKfr48Onwadgpk3Yisa_GdByzCPhVeBrr00x5N",
    contact: "9-1-1",
    contactName: "Franco Peralta (hijo)",
    caseId: "ESP-2026-0419",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },

  // ── NUEVOS CASOS ─────────────────────────────────────────────────────────
  {
    id: "fallback-055",
    name: "Franchezca Maria Peguero Pena",
    age: 14,
    gender: "Femenino",
    lastSeen: "2026-10-02",
    lastSeenTime: "07:00 PM",
    location: "Villa Consuelo, Santo Domingo",
    province: "Distrito Nacional",
    description: "Menor de 14 años. Vista por última vez alrededor de las 7:00 de la noche con un abrigo gris y una mochila. Podría estar molesta por una corrección de su madre, quien le había cortado el cabello luego de que la menor se fuera sin permiso a una piscina.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEiePbZPb5nbUmnqYmVQoGCnVM9Sb7-SQGdRe6hmBnwesBB2a-BPYy_nzv4dBr3VS0LhIsLC-DDMoJM8iXsLRQ2OpfoRi_YjYYamBJrn79mZbmnsr5fSVL1TTj93RiN1YnuER9YcnFY0OW-y2TSZpDRhGG2kCLKv4pkVrGlvyHSX8jQyQ2EURitrrYXdQzwX",
    contact: "809-460-9608",
    contactName: "Johanna Elizabeth (madre)",
    caseId: "ESP-2026-1002FP",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-056",
    name: "Nicol Ruben",
    age: 15,
    gender: "Femenino",
    lastSeen: "2026-10-01",
    lastSeenTime: "",
    location: "El Chaparral",
    province: null,
    description: "Menor de 15 años. Vista por última vez en El Chaparral. Al momento de su desaparición vestía un enterizo gris.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhe6OVwlLzVoHNh5g2TSye8tzmpRyiwo9Zs68y2B0Y-FP41MzuFz6PEYldOYRMdyB9dlX5Iej0IdFC8Ow5dIgxsWgidqg00jdrZPA-H7sAlClG1bD5QGPSEoiR1x7E4kUJCMhpOfByTRgrBa7UeHZ_3MvC8N3C1xu9qrRuVAB6XKIq22ff6vHgfij2CnCba",
    contact: "809-416-4491",
    contactName: "Familiar",
    caseId: "ESP-2026-1001NR",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-054",
    name: "Bartolo Cruz",
    age: +30,
    gender: "Masculino",
    lastSeen: "2024-09-28",
    lastSeenTime: "",
    location: "República Dominicana",
    province: null,
    description: "Desaparecido desde el 28 de septiembre de 2024. Su familia lo extraña profundamente y solicita la colaboración de toda la ciudadanía. Ya lleva más de dos años desaparecido. Si lo ves, retenlo y comunícate de inmediato con sus familiares.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiLzqsgn7Fdy_ffkv71kZi7p1rb1M_toL8DvNtc5sn2VGYS0R393OX2AOiar1wIT2gz-mBQTLGV10HIW8lSj0incZLTVZqb2dD5DNIJN1eY1Bs9jDkcphBo5g2DvsDKdJBvxI52qid_rE44EPYcmr_Mhzqf4jPLYGFKCGx50Ebt5V_xebk643VDXyaU0v2P/s320/_Bartolo%20Cruz.png",
    contact: "829-695-1986",
    contactName: "Familiares",
    caseId: "ESP-2024-0928BC",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },

  {
    id: "fallback-057",
    name: "Juan Pablo (Alias Sasa)",
    age: null,
    gender: "Masculino",
    lastSeen: "2026-06-29",
    lastSeenTime: "",
    location: "Palo Verde, Montecristi",
    province: "Montecristi",
    description: "Conocido como 'Sasa'. Desaparecido desde el 29 de junio de 2026 en la comunidad de Palo Verde, Montecristi. Si tienes información, comunícate de inmediato.",
    status: "DESAPARECIDA",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiRgBc0rqvXXi5OtVftk-Wwh-7R72kMXIzdUP90MRlKV-hzT3JEZiJCIRC6YiwuoVMKlzsEl-oZo6SZJCw-dBHfox6QbZS__v7s9I8k4yWL0LSAMK2DX9JsybFEnfX2bjefOZRQGMeAXXXubJX_Uqoj2s77ib4F_EkoqoFbG2JeeekwvCAQjO15cAJqT0EF/w149-h200/_Bartolo%20Cruz.png",
    contact: "829-352-8578",
    contactName: "Familiar",
    caseId: "ESP-2026-0629JP",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },

  // ── ENCONTRADOS / DEP ─────────────────────────────────────────────────────
  {
    id: "fallback-058",
    name: "Amancio Elpidio Ruiz",
    age: 83,
    gender: "Masculino",
    lastSeen: "2026-10-11",
    lastSeenTime: "",
    location: "República Dominicana",
    province: null,
    description: "Adulto mayor de 83 años. Desapareció el 11 de octubre de 2026. Fue encontrado posteriormente en buen estado.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh-hvtMNK70dRfeia4Ym02QaUs6_T5cGRkOWRnkEXCDE5BNmQZSjXfBFXOR7I6lgKsNTgtUAmqRP1RpsuBozzoykWFXsemWOqG3Khm77CRFPaqYDlYNQuW4ahLWEKT8wcAPS7WYJyRnJziC_j9XT0j2gF8bs9wvVj4bXGZ1Miqs5MEl6m6AnXEzWStunrJd/w152-h200/image.png",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-1011AER",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Fue localizado. Gracias a todos los que colaboraron en su búsqueda.",
  },
  {
    id: "fallback-005",
    name: "Loyca Alvarado",
    age: 37,
    gender: "Femenino",
    lastSeen: "2026-10-01",
    lastSeenTime: "",
    location: "Km 8 1/2 Av. Independencia, Distrito Nacional",
    province: "Distrito Nacional",
    description: "Salio a un salon de belleza. Su vehiculo y pertenencias quedaron abandonados en el lugar.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjiFjGl1aHRdelpoivXcoBu0-cSFHZg4NWyRJ916CtO3jefLovI5sMQisySlD8RkU7vJwma0e4SxLMXcRMHI1GA47vUXPZTbaKbpjtWnAjNkrOWrYZgts3uDnIYQd6LzyC-k0nF1scjC0ZeQs3KERmBbHtHOSwA8C3xABOomDoOKLYawnSVlfmmkMYu0ijM",
    contact: "9-1-1",
    contactName: "Autoridades",
    caseId: "ESP-2026-1001",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Encontrada fallecida. Q.E.P.D. Justicia para Loyca.",
  },
  {
    id: "fallback-053",
    name: "Rochelsy Capellan",
    age: 12,
    gender: "Femenino",
    lastSeen: "2026-10-01",
    lastSeenTime: "04:30 PM",
    location: "Calle Los Peloteros, Quintas del Sur, San Cristobal",
    province: "San Cristobal",
    description: "Menor de 12 años residente en Sante 4. Vista por ultima vez luego de regresar de la escuela.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgbf_Ul5UdHMrp8Cz2pVPHwIvG01nwHgiL56SJdUVR3ilnkJakLARQmQRvIOwakW1p0RoyPpBBIucK6TYiJAhxX3mVK9XnS_jfM_xhrMwJnLYH6gHx-resNhHsDWXGZ5CHfjK_mtCFxt_9Fty3lrCONBwwoDCa73_g-FxACTEa7ceHKCYDHMTgQZ4VjcDe2",
    contact: "829-986-3487",
    contactName: "Familia",
    caseId: "ESP-2026-1001RC",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada con bien. Gracias a la colaboracion de la comunidad.",
  },
  {
    id: "d6fa5645-560c-4533-8d35-f2ec53febb6a",
    name: "Valerie Alvarez",
    age: 14,
    gender: "Femenino",
    lastSeen: "",
    lastSeenTime: "",
    location: "Santo Domingo",
    province: null,
    description: "",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhuEQCiO7WWTfsQRUtryQ2t1AGtk7z2uOQ4SUftBjHUxWnvZ7rBcaLqy3lYN2gecl0Mp1fPbGsPdWB40xBv5nEYoEHtiJSgkTfzCSDcjZi6g-QMN2r7Dmt7SyW1ybvmZ69ciepphyYCX_QFTzT3ByBWoG_1S0RcjMnYXgfXKUbEOrg6Ir7oXqcx82gkIN61",
    contact: "",
    contactName: "",
    caseId: "ESP-2026-7383",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada con bien.",
  },
  {
    id: "fallback-002",
    name: "Melvin Diaz Fidanque",
    age: 42,
    gender: "Masculino",
    lastSeen: "2026-04-02",
    lastSeenTime: "",
    location: "Barahona",
    province: "Barahona",
    description: "Ojos color cafe.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEi8JLGczL_X1mrpnmdt4BUZhe-jkzCYeBJxphYrxaaIX2-SMpmjEv-hWJd92oVlHgK9suq7OEI0abU7eq9TB40r3HA1g0qqW_GhJYt6tJQgXEGULJECDp36lq2YDdzD-P2WXoT-pJ1fHIWqme6nnzrmW4dnZvxURtHGm9aC2T2Ohv9tfe8ZXMNXxI2-dAzm",
    contact: "849-496-4239",
    contactName: "Familiar",
    caseId: "ESP-2026-0402",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizado con bien.",
  },
  {
    id: "fallback-003",
    name: "Paul Kilgour",
    age: 38,
    gender: "Masculino",
    lastSeen: "2026-01-01",
    lastSeenTime: "",
    location: "Bavaro, Punta Cana",
    province: "La Altagracia",
    description: "Ciudadano escoces. Recibia atenciones de salud mental.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEiaC-JToAMmbBG5syqY_RyYLCTt7h7FMwP4h2teoc-GPOdm-Ocqgk9uDHwIvM0yH_eTDkzkdgPpxNjeysS_90XScRDAkQbv3SylSPvgFIo2FnniNk48fZtoLTtrQ84ZwXWakEYgzFcV3vUXHLTVLPuySILm_26J0sLQjJASa__Jf6xJIX79kvoK8xpWzXOK",
    contact: "849-396-9657",
    contactName: "Familiar",
    caseId: "ESP-2026-0001",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizado con bien.",
  },
  {
    id: "fallback-016",
    name: "Laider Leroux",
    age: 33,
    gender: "Femenino",
    lastSeen: "2026-09-17",
    lastSeenTime: "03:00 PM",
    location: "Los Unidos, La Caleta, Santo Domingo",
    province: "Santo Domingo",
    description: "Vestia t-shirt morado y jeans azul. Tez clara, cabello castano oscuro largo, ojos cafes, estatura 5'3\".",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEjbuZBbWUdnRQv7I28Dmftq0mlWCIwR9QNatTojGRaArLXh5_FzO3UqN_dAL7Zi4IZP3WlGmhAJSh0bBOTwIaaLvKCLwcmC12HH7q6gX9_p_3ruos_UR7RDeDMQ0rVRVcSct1ycAbrq3gfkG_gLSCYRnjWyuTMqrUwViqcnPCMLlkbTZZuVrFCozRe1ryul",
    contact: "829-519-3836",
    contactName: "Familiar",
    caseId: "ESP-2026-0917",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada con bien el 17 de septiembre de 2026.",
  },
  {
    id: "fallback-029",
    name: "Nashley Franchesca",
    age: 16,
    gender: "Femenino",
    lastSeen: "2026-07-17",
    lastSeenTime: "",
    location: "Sector Ceuta El Eden, Santo Domingo Norte",
    province: "Santo Domingo",
    description: "Menor de 16 años. Piel india, cabello castano corto, contextura delgada.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhlk5FcM7DNiQi9COIIreto9BOx2JOmIuUFdECkIfZ-fjCtjAqUCfgFxaTOcTxnB_85utfZ8pdy5D6MzJae0iVQW-ps0wUNK6FwwMVRGkf_G2__WPO2dJKpSxeNbxFr7ie_D-uZJMe1juGl2HNFTRiiz6j5WQp-ZcX2u5KkZbGGoC6ado9erCeqL1qjes5O",
    contact: "829-878-5767",
    contactName: "Familiar",
    caseId: "ESP-2026-0717",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada con bien.",
  },
  {
    id: "fallback-030",
    name: "Hillary Liz Fernandez",
    age: 14,
    gender: "Femenino",
    lastSeen: "2026-07-10",
    lastSeenTime: "03:30 PM",
    location: "Los Mina, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Menor de 14 años. Salio a comprar una tostada cerca de su residencia.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgFYq0UIA2IO9oYAZgzQMSUO7JFLCPORKoDUBhJFJSlObAo8oQWhyg2JA90pkrZvb0XEbN0C4nxtchyjGWFYJiEscZDqzcRuObopSU-fz-4wCOqgXp0f1yErAWhdAadcHZz9OQSRJCkkeKNXpq1CKQt93tLIlns0UCV7XHN4mTJcG2MFfm2Wp56BPm-NCkE",
    contact: "829-209-4040",
    contactName: "Familiar",
    caseId: "ESP-2026-0710B",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada con bien.",
  },
  {
    id: "fallback-031",
    name: "Oquitel Ramirez Villalona",
    age: 60,
    gender: "Masculino",
    lastSeen: "2026-06-21",
    lastSeenTime: "",
    location: "Villa Mella, Santo Domingo Norte",
    province: "Santo Domingo",
    description: "Padecia asma y presencia de perdida de memoria.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgIvmMTjVV_cAlRgMYajHN4io_dBjAJEkI-5R65UNQLRir-AjwZKwTUh2E-OyK3_n90Djrsu5-n9euANZ7nrbBDOhXqBtJ7TVQEjC68by3Fm0mhvm3y_P64IPeE6qZju4-FNgp5ivpHqDlBKICMe9ehxIr92e4PgP1E5d1M2VUfSZssUAGRYLbWkr5iwv4d",
    contact: "829-509-9331",
    contactName: "Familiar",
    caseId: "ESP-2026-0621",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Hallado sin vida en las aguas del rio Ozama. Q.E.P.D.",
  },
  {
    id: "fallback-046",
    name: "Danny Gabriel",
    age: null,
    gender: "Masculino",
    lastSeen: "2026-06-17",
    lastSeenTime: "",
    location: "Santo Domingo",
    province: "Distrito Nacional",
    description: "Joven reportado como desaparecido desde el miercoles 17 de junio de 2026.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEi9-IN8tDU9TXmrzHfgh6dxH0KrV4z_JlSaP3nvZVbDeIZbWTKPhzITcvoLzulbbSCR0M0jN9MhIXerQGBfJfMb2f2WKnuGe_B4sFOt0JuIXUvdPlxiduUedPPz2mJiVdfeht_MS5_edryp-Vm4hLCewfTuzgUY3nRulEikNPn5OBm1O3NGrJmkurGeatBy",
    contact: "",
    contactName: "Nurys (madre)",
    caseId: "ESP-2026-0617D",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizado con bien. Gracias a la comunidad.",
  },
  {
    id: "fallback-047",
    name: "Isaias Otoniel Araujo",
    age: null,
    gender: "Masculino",
    lastSeen: "",
    lastSeenTime: "",
    location: "Brisas del Este, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Residente en el sector Brisas del Este.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgvaLiI4WhpZwy-mYbO7wAYzRPcagKj7LerXaq9dnTk40-TVftqGOC5i9PluhR-e_hKDBuZkMu2liFUIJkySi4HSMRbNd7N65Z9b3yoS3NZF8DB75qH6WHIDFFxjJQ40bhBfLdPPFsV4QPofJF7HckWR2Hg_pETcN065Ai4BE47K3XcMvtwMCAmfdzgW1xq",
    contact: "",
    contactName: "Familiar",
    caseId: "ESP-2026-0000IA",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizado con bien. Gracias a la comunidad.",
  },
  {
    id: "fallback-048",
    name: "Emily Alexandra Gutierrez",
    age: null,
    gender: "Femenino",
    lastSeen: "",
    lastSeenTime: "",
    location: "Manoguayabo, Santo Domingo Oeste",
    province: "Santo Domingo",
    description: "Menor localizada en el sector de Manoguayabo.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEiso9rjCbJNsdjxzsA78HbfQqomUwITWDB4pXrcmPQX0Uk35_-NCF5iLLcvZiS3bs4VnsZYS2IOllC-Z-pdLjb55qt7ncW9V-l-Qbj72p6EhbEd0lO9TICEUO14L1uQ09HrmQt52bZU0mMgPNJm97YP02OfK9ESdu_GDXIixUAQqPY_S5y2WpVoxmGXI2Rc",
    contact: "",
    contactName: "Familiar",
    caseId: "ESP-2026-0000EG",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada sana y salva en Manoguayabo.",
  },
  {
    id: "fallback-049",
    name: "Domingo Anibal Pimentel",
    age: 79,
    gender: "Masculino",
    lastSeen: "2026-03-31",
    lastSeenTime: "",
    location: "Grand Concourse, Nueva York",
    province: null,
    description: "Reportado como desaparecido desde el martes 31 de marzo de 2026 en la zona de Grand Concourse, Nueva York.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEgRP5a_GtIvoN-B1QH48Bf2vMCWF6M81OrhvozsDjDf0Po0pcFaLsrZxx-yVULk9WTN5PWgE47oGr78zmrYCIfDBZbdfe0t-VKLwT-tGSbiJ6JXfrkj4uUXq8pk5bGBXYDShVq5xrXsJvxaDtUtZNdLtk2S8Y5h6laxpfM7xswKECubkJ4xxp05Rpi90Q0G",
    contact: "",
    contactName: "Familiar",
    caseId: "ESP-2026-0331",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizado con bien en Nueva York. Gracias a la comunidad dominicana.",
  },
  {
    id: "fallback-050",
    name: "Dolores Canela Ramirez de Marte",
    age: 78,
    gender: "Femenino",
    lastSeen: "",
    lastSeenTime: "",
    location: "San Vicente de Paul, Santo Domingo Este",
    province: "Santo Domingo",
    description: "Reportada como desaparecida en el sector San Vicente de Paul.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEhpIyne4tfAU3ClETH96qO6ztVKa1ITbj0YtwirWRKP5L9JBnYxqCULbmMLC-UKtH7GPJTi1Pn4bW9RZCtJlePVX3UYl1Dr3gnflN0kVrYbkUXf7ZlJVscm0CDqSTIDbgyE1JjGVOHyCqjmNPyPoJJRki_0t0ECVQfzL9rg6obmbgmKjaRII0KiGFuxPoxe",
    contact: "",
    contactName: "Familia Canela Marte",
    caseId: "ESP-2026-0000DC",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Localizada sin vida. Q.E.P.D. Condolencias a la familia.",
  },
  {
    id: "fallback-051",
    name: "Candido Figueroa (Ricky)",
    age: 46,
    gender: "Masculino",
    lastSeen: "2026-04-22",
    lastSeenTime: "",
    location: "Santo Domingo",
    province: "Distrito Nacional",
    description: "Chofer del INABIE. Encontrado sin vida en una casa en construccion.",
    status: "ENCONTRADO",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEijFAYwmL3x3qkf0X0fDbGURVNuts0ZMBp_vRNRGSU77qejnkkSsTlVUcs731j5kZx6LNdXVE4S4QR27XNJZho5nOArxt2wS4Hm5pIAw_VIkOZQ7ORF9VcmQzkOoV-Eeo3NYeAmRgurVWI3Yccq5HbhvcN-HPBsTW0xFgb8iflUt6uQHyoKI30K_S279uY7",
    contact: "",
    contactName: "Familia",
    caseId: "ESP-2026-0422",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Encontrado sin vida en una casa en construccion. JUSTICIA PARA RICKY. Q.E.P.D.",
  },
  {
    id: "fallback-052",
    name: "Carli Franchesca Guzman Roche",
    age: 21,
    gender: "Femenino",
    lastSeen: "2021-09-13",
    lastSeenTime: "",
    location: "Pizarrete, Peravia",
    province: "Peravia",
    description: "Desaparecio el 13 de septiembre de 2021. Su cuerpo fue hallado sin vida enterrado en una propiedad en Puerto Plata tras mas de cuatro años de busqueda.",
    status: "ENCONTRADA",
    photoUrl: "https://blogger.googleusercontent.com/img/a/AVvXsEiTRuqVYFLciQwrnLYlmWrSTK258LZgYGwsE7Bn2lps7Ck05SWncBgCxssH--lhDr23oi_THQ6Aa6JqdKEe3nlW6UzExJhcENrEaq4pZn6kCfd0flZCoRCQl4S11wmdeeUnAVW1lqwa8FoNS-OTTp1nrOJmkJZs2eaTH00uZMTp0maNaE952vQ8I3el7Mrf",
    contact: "",
    contactName: "Familia Guzman Roche",
    caseId: "ESP-2021-0913",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: "Hallada sin vida enterrada en Puerto Plata tras 4 años. La familia exige justicia. Q.E.P.D.",
  },
  {
    id: "fallback-060",
    name: "Anderson Santos",
    age: null,
    gender: "Masculino",
    lastSeen: "2026-10-04",
    lastSeenTime: "",
    location: "La Garza, San José de Matanzas, Nagua",
    province: "María Trinidad Sánchez",
    description: "Conocido como Andy. Oriundo de la comunidad La Garza, perteneciente al distrito municipal San José de Matanzas, municipio de Nagua. Lleva dos semanas desaparecido. El DICRIM prevé realizar búsqueda en parcelas agrícolas y zonas boscosas de la localidad.",
    status: "DESAPARECIDO",
    photoUrl: "",
    contact: "829-354-7167",
    contactName: "Madre de Anderson",
    caseId: "ESP-2026-1004",
    reportedBy: "El Nuevo Diario",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-061",
    name: "Ochi (nombre completo no disponible)",
    age: 12,
    gender: "Femenino",
    lastSeen: "2026-10-14",
    lastSeenTime: "",
    location: "La Circunvalación / La Victoria, Santo Domingo",
    province: "Santo Domingo",
    description: "Conocida cariñosamente como 'Ochi'. Desapareció de su vivienda mientras su abuela descansaba, luego de regresar juntas de una actividad religiosa. La menor estaba realizando labores domésticas cuando dejó de ser vista. Ha sido reportada en las zonas de La Circunvalación y La Victoria. Criada por su abuela Ramona Sosa.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEigvFJBS83NqsO1OXNAbvPNgnC5o88bm6oYEnVAtp42NS2ogh0TFePeggBhibLUJDZKilZfI9CybtM1yLJ9yrP1ls2FvVpVtXhEpmoCMG0XGf6FZFenoAAnksxnDauCw1ihLGuzIoQKPRFNwlcUyjPbfQb1RJ7GgNHBTAjUzi6267YYm1lUZRst8SKOHIiP/w149-h200/Ochi.png",
    contact: "849-255-7413",
    contactName: "Ramona Sosa (abuela)",
    caseId: "ESP-2026-1014",
    reportedBy: "De Último Minuto",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-062",
    name: "Johanfry Alexander Escolástico",
    age: 24,
    gender: "Masculino",
    lastSeen: "2026-10-17",
    lastSeenTime: "11:00 PM",
    location: "Nueva Isabela, Guaricano",
    province: "Santo Domingo",
    description: "Salió de su vivienda en el sector Nueva Isabela, Guaricano, el viernes en la noche y no ha regresado. Vestía polo blanco, pantalón jean claro y chancletas de goma color casi negro. Vive con su madre, abuela y una hermana menor. Está dentro del espectro autista.",
    status: "URGENTE",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj4pFWLUMoQUqKA8IWjFPvZOt8pzWAlUDXyQPOhYnZNdbTjVpuBmxc8NcsWqWbJ06R7wwqjDotQqVP_2_pm0PsIbewXaLrf98M-QPbdxSuGuKTjvP7Y-1MYMaL_R8gLisSnvBh71hqUu1pKtguqQ-A6EvzLpVJQ3gWv-u2ATxY1qToWgNyQSg76DMlHYHni/w196-h200/image.png",
    contact: "829-910-2745",
    contactName: "Negrita (madre) / Zoila (abuela): 849-564-5483 / Priscila (tía): 829-557-8681",
    caseId: "ESP-2026-1017",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-063",
    name: "Ashley Yolenny Ortega Ayala",
    age: 11,
    gender: "Femenino",
    lastSeen: "2026-10-20",
    lastSeenTime: "1:00 PM",
    location: "Barrio Santa Rosa, Bonao",
    province: "Monseñor Nouel",
    description: "Desapareció el martes después de salir de la escuela Profesor Guaroa Moreta, ubicada en el barrio Santa Rosa, Bonao. Reside en la esquina Central de ese barrio. Su familia desconoce su paradero desde su salida del centro educativo.",
    status: "ENCONTRADA",
    foundNote: "Encontrada el 21 de octubre de 2026. ¡Gracias a todos los que compartieron!",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhNZOho6gS2kQmfmNkvbmWqwd-bNztZOaxk4o_4n9uMJm4w05Rcy4RVNz9cFTdZwqUYFxXDmqV1Di9y4i34JFB0VGivdtZE6ble0Y1AmNckh_9gcDy1fJsm7ceCq84q4wv842Bd7v_1ZnZ12KZ2w3e8dI6Ti2oJyZQvkdZDgoYPjG26VzlPAWk2vUodhsP6/w149-h200/Ashley%20Yolenny%20Ortega%20Ayala.png",
    contact: "809-459-3533",
    contactName: "Tía",
    caseId: "ESP-2026-1020",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-064",
    name: "Dorianny Ramírez Martínez",
    age: 9,
    gender: "Femenino",
    lastSeen: "2026-10-29",
    lastSeenTime: "",
    location: "Higüey",
    province: "La Altagracia",
    description: "Niña de 9 años reportada como desaparecida en Higüey. Caso reportado por ASODOFADE.",
    status: "ENCONTRADA",
    foundNote: "Encontrada el 29 de octubre de 2026. ¡Gracias a todos los que compartieron!",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgcG63lcilLp7a6OnReh4R4xRLEJWEgsOr26zD_uvS0vv8Z0mjBE34dd83XZ3C2l7V9eYFeJoWOBNmWkqERj-lvwTYpH70f7jH4yH6Q03spHlndhgzHIXXI6RNwHi2x9GcPZY9iYl0vqWrFjGCAAV83ykI1a8GRNIjA0IT8bl2FyZGGJXGyoZeZGMxSQRBr/w149-h200/Copia%20de%20Ashley%20Yolenny%20Ortega%20Ayala.png",
    contact: "809-376-1943",
    contactName: "Fanny",
    caseId: "ESP-2026-1029",
    reportedBy: "ASODOFADE",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-065",
    name: "Laura Virginia Espinosa Ruiz",
    age: 47,
    gender: "Femenino",
    lastSeen: "2026-10-29",
    lastSeenTime: "",
    location: "Sabana Perdida → San Isidro",
    province: "Santo Domingo",
    description: "Salió de su residencia en Sabana Perdida con destino a su trabajo en un salón de belleza en San Isidro el jueves 29 de octubre y nunca llegó a su destino. Cabello negro, ojos marrones claros, piel mestiza.",
    status: "ENCONTRADA",
    foundNote: "Encontrada el 1 de noviembre de 2026. ¡Gracias a todos los que compartieron!",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhCVrCKzlel_w5AAVD-i0RMMWjhpdDZ_BXJQu21dGA9sHbLsqla2KAZ7RC7MkX7lVLD_5qSveOvhWq2YUKsCqhsc9aseIB-FJCkS67haEbNLVBivGoqBMIeGFz5YslnZC7w29NsmgIgErD1c773FbI5JIVHxJdKpj2MPOfeBT2i4U_cxYOyC3haRZMJZU8N/w149-h200/Laura%20Virginia%20Espinosa%20Ruiz%20encontrada.png",
    contact: "809-884-6966",
    contactName: "Familiares (también: 829-747-8633)",
    caseId: "ESP-2026-1029B",
    reportedBy: "N Digital Multimedia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-066",
    name: "William Rodríguez Castillo",
    age: 42,
    gender: "Masculino",
    lastSeen: "2026-10-29",
    lastSeenTime: "",
    location: "Salió de su residencia hacia su lugar de trabajo",
    province: "Sin especificar",
    description: "Salió de su residencia el jueves 29 de octubre con destino a su lugar de trabajo en labores de construcción de platos. Hasta el momento se desconoce su paradero.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgmD5xFc6SYMMzPNcwwuEnKOFqE26_vbSVTaTqTpgpI_RL5f4AnpD5sqObsAXumD0rWB78RrldRuzGNuFG6LEdnEbV3xQ4Mre_JAcKVFzponI2f8X5cm8VTsGQ-CXuC2hqmahUIsqX2k_6_Cze5_82kmaPs3riHiP6DWIryMkk_NJAqXoTLz9T6R740APIg/s1600/image.png",
    contact: "",
    contactName: "Familiares",
    caseId: "ESP-2026-1029C",
    reportedBy: "De Último Minuto",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
  {
    id: "fallback-067",
    name: "Aíshlan Andrady Romero Rodríguez",
    age: null,
    gender: "Sin especificar",
    lastSeen: "2026-10-01",
    lastSeenTime: "",
    location: "Cotuí",
    province: "Sánchez Ramírez",
    description: "Salió del municipio de Cotuí hace aproximadamente un mes. Sus teléfonos permanecen apagados y no responde llamadas ni mensajes. Su familia desconoce su paradero.",
    status: "DESAPARECIDO",
    photoUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgaBI04eySHMvS3Lf1QiQlTfidmKVM9QImt_p45y9PSVgqaN42wvVCcDlYi7B_gtKQz8c4IYFnwsBgjn5zWEdve5t5nvKCw1YOWXaInOKtpQLCfukVEDsaNp1BB2N1s2SgJtEgCpc-cbHMJZsUx9E-FnDtmB0f2qdfOZCs8fdEw2cofN4zK4_SIVnZVI6BN/s1600/image.png",
    contact: "809-763-4247",
    contactName: "Familiares",
    caseId: "ESP-2026-1001",
    reportedBy: "Familia",
    daysActive: 0,
    shared: 0,
    policeReport: null,
    foundNote: null,
  },
];

function calcDaysActive(person) {
  if (person.status === 'ENCONTRADA' || person.status === 'ENCONTRADO') return 0;
  if (!person.lastSeen) return 0;
  const last  = new Date(person.lastSeen);
  const today = new Date();
  const diff  = Math.floor((today - last) / (1000 * 60 * 60 * 24));
  return diff > 0 ? diff : 0;
}

export const FALLBACK_PERSONS_WITH_DAYS = FALLBACK_PERSONS.map(p => ({
  ...p,
  daysActive: calcDaysActive(p),
}));